import {
  Directive,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import {
  filter,
  withLatestFrom,
} from 'rxjs/operators';
import { Router } from '@angular/router';
import { rxEffects } from '@rx-angular/state/effects';

@Directive({
  selector: '[libKeyboardRouteNavigation]',
  standalone: true,
})
export class KeyboardRouteNavigationDirective implements OnInit {
  private readonly router = inject(Router);
  private readonly effects = rxEffects();

  @Input('libKeyboardRouteNavigation')
  navigation$!: Observable<{ prev?: { url: string }; next?: { url: string } }>;

  ngOnInit(): void {
    const keydown$ = fromEvent<KeyboardEvent>(document, 'keydown').pipe(
      filter((e) => !['INPUT', 'TEXTAREA'].includes((e.target as HTMLElement).tagName)),
      filter((e) => e.key === 'ArrowRight' || e.key === 'ArrowLeft')
    );

    this.effects.register(
      keydown$.pipe(withLatestFrom(this.navigation$)),
      ([event, nav]) => {
        const url = event.key === 'ArrowRight' ? nav.next?.url : nav.prev?.url;
        if (url) this.router.navigate([url]);
      }
    );
  }
}
